import { render, staticRenderFns } from "./uping.vue?vue&type=template&id=462643ad&scoped=true&"
import script from "./uping.vue?vue&type=script&lang=ts&"
export * from "./uping.vue?vue&type=script&lang=ts&"
import style0 from "./uping.vue?vue&type=style&index=0&id=462643ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "462643ad",
  null
  
)

export default component.exports